export const background = '#264A18';

export const border = '#FFCF88';
